import { ChangeEvent, FC, useCallback, useRef, useState } from "react";
import Icon from "../../Icon/Icon";
import styles from "../FormInputs.module.css";
import { TextInputProps, getErrorMessage } from "../types";

export const TextAreaInput: FC<TextInputProps> = ({
  name,
  label,
  required,
  disabled,
  error,
  autoComplete,
  registration,
  value,
  onChange,
  maxLength,
  showErrors = true,
}) => {
  const errorMsg = getErrorMessage(error);
  const [charCount, setCharCount] = useState(0);
  const initialised = useRef(false);

  const handleInput = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      setCharCount(e.target.value.length);
      void registration?.onChange?.(e);
      onChange?.(e);
    },
    [registration, onChange]
  );

  const refCallback = useCallback(
    (el: HTMLTextAreaElement | null) => {
      registration?.ref(el);
      if (el && !initialised.current) {
        initialised.current = true;
        requestAnimationFrame(() => setCharCount(el.value.length));
      }
    },
    [registration]
  );

  const regProps = registration
    ? { ...registration, onChange: handleInput, ref: refCallback }
    : { name, value, onChange: handleInput };

  return (
    <div
      className={`${styles["input-wrapper"]} ${disabled ? styles.disabled : ""}`}
    >
      <label htmlFor={name}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
      <textarea
        id={name}
        autoComplete={autoComplete}
        className={
          error
            ? styles.error
            : "" + (maxLength !== undefined ? ` ${styles.short}` : "")
        }
        disabled={disabled}
        maxLength={maxLength}
        {...regProps}
      />
      {maxLength !== undefined && (
        <span className={styles["char-counter"]}>
          {charCount} / {maxLength}
        </span>
      )}
      {error && <Icon name="Warning_circle_1" className={styles.icon} />}
      {showErrors && <p className={styles["required-error"]}>{errorMsg}</p>}
    </div>
  );
};
